import React, { ReactElement } from 'react';
import { NextPageWithLayout } from 'next';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { useIntl } from 'react-intl';
import markdown from '../data/staticPages/code-of-ethics.md';
import Layout from '../components/Layout';
import LinkAndAnchor from '../components/LinkAndAnchor';
import messages from '../lib/messages.json';
import Head from '../components/Head';
import HomeLink from '../components/HomeLink';
import Markdown from '../components/Markdown';

const CodeOfEthicsPage: NextPageWithLayout = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="code-of-ethics"
      passHref
    >
      {intl.formatMessage(messages.codeOfEthics)}
    </LinkAndAnchor>,
  ];
  return (
    <>
      <Head
        title={intl.formatMessage(messages.codeOfEthics)}
        description={intl.formatMessage(messages.codeOfEthics)}
      />
      <StaticPageComponent
        breadcrumbs={breadcrumbs}
        content={<Markdown markdown={markdown} />}
        title={intl.formatMessage(messages.codeOfEthics)}
      />
    </>
  );
};

CodeOfEthicsPage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

export default CodeOfEthicsPage;
